// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export const gallery = () => {
  const els = document.querySelectorAll('.is-style-carousel');

  if (els?.length > 0) {
    els.forEach((el) => {
      $(el)
        .addClass('swiper')
        .find('ul')
        .removeClass('blocks-gallery-grid')
        .addClass('swiper-wrapper')
        .find('li')
        .removeClass('blocks-gallery-item')
        .addClass('swiper-slide');

      const thumbs = document.createElement('div');
      $(thumbs).addClass('thumbs swiper').html(el.innerHTML);

      $(el).closest('.media').append(thumbs);

      const thumbsSwiper = new Swiper(thumbs, {
        spaceBetween: 10,
        slidesPerView: 3,

        // enable click nav + add threshold to prevent accidental scrolling on clicks
        slideToClickedSlide: true,
        threshold: 5,

        watchSlidesProgress: true,
        freeMode: true,
      });

      const gallerySwiper = new Swiper(el, {
        spaceBetween: 10,

        thumbs: {
          swiper: thumbsSwiper,
        },
      });
    });
  }
};
